import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import classNames from 'classnames/bind';

import Link from 'components/helpers/Link/Link';
import Button from 'components/helpers/Button/Button';
import { GetLinkFieldIcon } from 'models/fields';

import { contextType, HeaderContext, NavSections } from './Header';
import Subnavigation from './Subnavigation';

import styles from './Header.module.scss';

const cx = classNames.bind(styles);

type PrimaryNavItemProps = {
  index: number;
  navItem: NavSections;
};

const PrimaryNavItem = (props: PrimaryNavItemProps): JSX.Element | null => {
  const {
    isMobile,
    openMenu,
    openSubNav,
    setOpenSubNav,
    handleBlur,
    resetMobileMenu,
    currentLang,
    currentPage,
    datasourceLanguage,
  } = React.useContext(HeaderContext) as contextType;
  const subNavId = `sub-nav-${props.index}`;
  const isOpen = openSubNav?.startsWith(subNavId) || false;
  const { sitecoreContext } = useSitecoreContext();

  const handleFocus: React.FocusEventHandler<HTMLButtonElement> = (e) => {
    const target = e.target as HTMLButtonElement;
    if (!target?.classList?.contains('primary') && openSubNav !== null) {
      setOpenSubNav(null);
    }
  };

  if (props.navItem.subNavSections?.length) {
    return (
      <li
        key={props.index}
        className={cx('header__primary-nav-menu-item', {
          'header__primary-nav-menu-item--current': props.navItem.isDescendant,
        })}
      >
        <Button
          type="button"
          lang={datasourceLanguage ?? currentLang}
          icon={isMobile ? 'carat' : undefined}
          tabIndex={isMobile && !openMenu ? -1 : 0}
          aria-controls={subNavId}
          aria-expanded={isOpen}
          onClick={() => {
            if (isOpen) {
              setOpenSubNav(null);
            } else {
              setOpenSubNav(subNavId);
            }
          }}
          onBlur={handleBlur}
          onFocus={handleFocus}
        >
          <Text field={props.navItem.title} encode={sitecoreContext.pageEditing} />
        </Button>
        <Subnavigation id={subNavId} sections={props.navItem.subNavSections} isOpen={isOpen} />
      </li>
    );
  }

  if (props.navItem.link != null && props.navItem.link?.value.href != '' && props.navItem.title?.value != '') {
    return (
      <li
        key={props.index}
        className={cx('header__primary-nav-menu-item', {
          'header__primary-nav-menu-item--current': props.navItem.isDescendant,
        })}
      >
        <Link
          field={props.navItem.link}
          lang={datasourceLanguage ?? currentLang}
          aria-current={props.navItem.link?.value.href == currentPage ? 'page' : undefined}
          icon={GetLinkFieldIcon(props.navItem.link)}
          tabIndex={isMobile && !openMenu ? -1 : 0}
          showLinkTextWithChildrenPresent={false}
          onFocus={() => {
            setOpenSubNav(null);
          }}
          onClick={() => {
            resetMobileMenu();
          }}
        >
          <Text field={props.navItem.title} encode={sitecoreContext.pageEditing} />
        </Link>
      </li>
    );
  }

  return null;
};

export default PrimaryNavItem;
